import { RefSelectProps, SelectProps } from "antd";
import { ReactNode, useRef, useState } from "react";
import { SelectItemTagRender } from "src/content/tools/alerting/AlertingHistory";
import { DomUtil } from "src/util/DomUtil";
import { GLOB } from "src/util/Glob";
import { XmSelect } from "./XmSelect";
import './select.less';

interface XmTagReadOnlySelectProps extends Omit<SelectProps, 'value' | 'options'> {
  tags: string[];
  /** Custom dropdown option content for a tag; defaults to the tag itself */
  optionLabel?: (tag: string) => ReactNode;
}

const XmTagReadOnlySelect = ({ tags = [], optionLabel, onOpenChange, ...props }: XmTagReadOnlySelectProps) => {
  const [search, setSearch] = useState('');
  const selectRef = useRef<RefSelectProps>(null);
  const sorted = [...tags].sort(GLOB.naturalSort);

  return <XmSelect
    // Tags are hidden while searching so the typed text does not merge with the "+N" placeholder
    className={search ? "xm-tags-read-only-select xm-tags-read-only-select-searching" : "xm-tags-read-only-select"}
    classNames={{ popup: { root: "xm-select-readonly" } }}
    mode='multiple'
    popupMatchSelectWidth={true}
    maxTagCount='responsive'
    style={{ width: '100%' }}
    menuItemSelectedIcon={null}
    removeIcon={null}
    size="small"
    suffix={null}
    tagRender={SelectItemTagRender}
    variant="borderless"
    {...props}
    getPopupContainer={DomUtil.popupToBody}
    showSearch={{ optionFilterProp: 'value', searchValue: search, onSearch: setSearch }}
    // rc-select swallows mousedown on a custom-rendered tag, so the search input would stay unfocused
    onOpenChange={open => {
      if (open) selectRef.current?.focus({ preventScroll: true });
      else setSearch('');
      onOpenChange?.(open);
    }}
    ref={selectRef}
    value={sorted}
    options={sorted.map(t => ({
      value: t,
      label: <div className='xm-tree-title'>{optionLabel ? optionLabel(t) : t}</div>,
    }))}
    ignoreReadonly
  />;
};

export default XmTagReadOnlySelect;